import axios from "axios";

const http = (useBaseUrl2 = false) => {
  let options = {
    //baseURL: "https://192.168.1.191:7116/api",
    baseURL: useBaseUrl2 ? process.env.REACT_APP_BASE_URL2 : process.env.REACT_APP_BASE_URL,
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  };
  if (localStorage.getItem("token")) {
    options.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  }
  return axios.create(options);
};

export const httpE = () => {
  let options = {
    //baseURL: "https://192.168.1.191:7116/api",
    baseURL: process.env.REACT_APP_BASE_URL?.replace("/api", ""),
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  };
  if (localStorage.getItem("token")) {
    options.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  }
  return axios.create(options);
};

export const getTenantFromUrl = () => {
  const { hostname } = window.location;
  const cleanHost = hostname.replace(/^www\./, "");
  const domainPart = cleanHost.split(".")[0];
  const tenant = domainPart.split("-")[0];

  if (!tenant || ["localhost", "admin", "payloft"].includes(tenant.toLowerCase())) {
    return null;
  }
  return tenant;
};

export default http;
